import { HTMLAttributes, PropsWithChildren } from 'react';
import { TaskDto } from '@sib/api';
import { useTranslation } from '@sib/i18n';
import { cn } from '@sib/ui';
import { FollowUp } from '@sib/ui/icons';
import { useTaskDetailsModalActions } from '../TaskForm/TaskDetailsModal/use-task-details-modal-route-params';

interface RelatedTaskBannerProps
  extends PropsWithChildren<HTMLAttributes<HTMLDivElement>> {
  task: TaskDto;
}

export const RelatedTaskBanner = ({
  className,
  task,
  ...props
}: RelatedTaskBannerProps) => {
  const { t } = useTranslation();
  const { openTask } = useTaskDetailsModalActions();
  const isChildTask = !!task?.parentTask;
  const relatedTask = task?.parentTask || task?.followUpTask;

  if (!relatedTask) return null;

  return (
    <div
      {...props}
      className={cn(
        'bg-info-subtle flex w-full items-center gap-1 rounded-md p-4 text-xs @5xl/tasks:rounded-none',
        className
      )}
    >
      <div className="flex flex-row gap-1 truncate">
        <FollowUp className="text-primary mr-0.5 size-4" />
        <div className="flex max-w-[90%] flex-row gap-1">
          {isChildTask
            ? t('components.taskList.followUp.previousTask')
            : t('components.taskList.followUp.nextTask')}
          <button
            type="button"
            onClick={() => openTask(relatedTask.uuid)}
            className="text-primary min-w-0 cursor-pointer truncate text-xs font-medium underline"
          >
            {relatedTask.title}
          </button>
        </div>
      </div>
    </div>
  );
};
